<script lang="ts">import { getContext } from 'svelte';
const { colorMode = 'light', direction = 'previous', disabled: disabledFromProps = false, parentBackgroundColor = 'white', onClick = () => { }, class: className = '', ...rest } = $props();
const carouselContext = getContext('carousel');
const emblaApi = carouselContext?.emblaApi;
const canScrollPrev = carouselContext?.canScrollPrev;
const canScrollNext = carouselContext?.canScrollNext;
const disabled = $derived.by(() => {
    const api = $emblaApi;
    if (disabledFromProps || !api) {
        // disabledFromProps could be true or false because the if statement is also checking if emblaApi exist, so return
        // the variable instead of just a boolean
        return disabledFromProps;
    }
    return direction === 'previous' ? !$canScrollPrev : !$canScrollNext;
});
function handleClick() {
    const api = $emblaApi;
    if (disabledFromProps || !api) {
        !disabledFromProps && onClick?.();
        return;
    }
    if (direction === 'previous') {
        api.scrollPrev();
    }
    else {
        api.scrollNext();
    }
    onClick?.();
}
</script>

<button
  {...rest}
  class="CarouselButton CarouselButton--{direction} CarouselButton--on-{parentBackgroundColor} {className}"
  data-color-mode={colorMode}
  aria-label="Go to {direction} slide"
  {disabled}
  onclick={handleClick}
>
  <svg width="21" height="22" xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M1.063 11.943a1.333 1.333 0 0 1 0-1.886L10.396.724l1.886 1.885-7.057 7.058h15.448v2.666H5.225l7.057 7.057-1.886 1.886-9.333-9.333z"
    />
  </svg>
</button>

<style>/**
 * Do not edit directly, this file was auto-generated.
 * Fri, 01 Aug 2025 11:58:03 GMT
 */
@layer design-system-components.pwds {
  .CarouselButton {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    height: var(--carousel-button-height, 5rem);
    width: var(--carousel-button-width, 5rem);
    background-color: var(--carousel-button-background-color, #f7f6f5);
    border: none;
    border-radius: 100%;
    cursor: pointer;
    transform: translateY(0) scale(1);
    transition: transform var(--duration-quick) var(--easing-decelerate);
  }
  .CarouselButton:after {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    border-radius: 100%;
    background-color: var(--carousel-button-overlay-color, rgba(0, 0, 0, 0.18));
    opacity: 0;
    transition: opacity var(--duration-quick) var(--easing-decelerate);
  }
  .CarouselButton[disabled] {
    cursor: not-allowed;
  }
  .CarouselButton:not([disabled]):focus-visible:not(:active) {
    outline: var(--accessibility-focus-outline-width) var(--accessibility-focus-outline-style, solid) var(--accessibility-focus-outline-color);
    border-radius: 100%;
    outline-offset: var(--accessibility-focus-outline-offset);
  }
  .CarouselButton:not([disabled]):hover:after {
    opacity: 1;
  }
  .CarouselButton:not([disabled]):active {
    transform: translateY(var(--carousel-button-active-translate-y, 5%)) scale(var(--carousel-button-active-scale, 0.95));
  }
  .CarouselButton--next svg {
    transform: scaleX(-1);
  }
  .CarouselButton[data-color-mode=light].CarouselButton--on-accent {
    --carousel-button-background-color: var(--color-neutral-800, tokens.$color-neutral-800);
    --carousel-button-overlay-color: var(--color-neutral-700, tokens.$color-neutral-700);
  }
  .CarouselButton svg {
    position: relative;
    z-index: 1;
    display: block;
    fill: var(--carousel-button-arrow-color, #000000);
  }
}</style>
